import React from "react";

function Blog() {
  return (
    <>
      <div className="home-blog-two-area default-padding bg-gray blurry-shape-left-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Latest Blog</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  News &amp; Update
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="blog-style-two-box">
            <div className="row">
              <div className="col-xl-4 col-lg-6">
                <div className="blog-style-two fade-up-anim">
                  <div className="thumb zoom-thumb">
                    <a href="#">
                      <img
                        className="img-reveal"
                        src="https://validthemes.net/site-template/robok/assets/img/blog/1.jpg"
                        alt="Thumb"
                      />
                    </a>
                  </div>
                  <div className="info">
                    <div className="blog-one-meta">
                      <ul>
                        <li>
                          <a href="#">Technolgoy</a>
                        </li>
                        <li>06 December, 2025</li>
                      </ul>
                    </div>
                    <h4 className="blog-title">
                      <a href="#">
                        Discovery incommode earnestly commanded if.
                      </a>
                    </h4>
                    <a href="#" className="btn-regular">
                      Read more
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/icon/arrow-right-three.png"
                        alt="Image Not Found"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6">
                <div className="blog-style-two fade-up-anim">
                  <div className="thumb zoom-thumb">
                    <a href="#">
                      <img
                        className="img-reveal"
                        src="https://validthemes.net/site-template/robok/assets/img/blog/2.jpg"
                        alt="Thumb"
                      />
                    </a>
                  </div>
                  <div className="info">
                    <div className="blog-one-meta">
                      <ul>
                        <li>
                          <a href="#">Artificial</a>
                        </li>
                        <li>14 August, 2025</li>
                      </ul>
                    </div>
                    <h4 className="blog-title">
                      <a href="#">
                        Expression acceptance imprudence particular.
                      </a>
                    </h4>
                    <a href="#" className="btn-regular">
                      Read more
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/icon/arrow-right-three.png"
                        alt="Image Not Found"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6">
                <div className="blog-style-two fade-up-anim">
                  <div className="thumb zoom-thumb">
                    <a href="#">
                      <img
                        className="img-reveal"
                        src="https://validthemes.net/site-template/robok/assets/img/blog/3.jpg"
                        alt="Thumb"
                      />
                    </a>
                  </div>
                  <div className="info">
                    <div className="blog-one-meta">
                      <ul>
                        <li>
                          <a href="#">Integration</a>
                        </li>
                        <li>12 July, 2025</li>
                      </ul>
                    </div>
                    <h4 className="blog-title">
                      <a href="#">
                        Considered imprudence of technical friendship.
                      </a>
                    </h4>
                    <a href="#" className="btn-regular">
                      Read more
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/icon/arrow-right-three.png"
                        alt="Image Not Found"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog;

// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function Blog() {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   const fetchBlogs = async () => {
//     try {
//       const response = await axios.get(
//         "http://localhost/blog-xeer/blog/api/latest-posts",
//       );
//       console.log("response.data.posts : ", response.data.posts);

//       // If API response is inside data
//       setBlogs(response.data.posts || response.data.posts || []);
//     } catch (error) {
//       console.error("Error fetching blogs:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="home-blog-two-area default-padding bg-gray blurry-shape-left-bottom">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-8 offset-lg-2">
//               <div className="site-heading text-center">
//                 <h4 className="sub-title">Latest Blog</h4>
//                 <h2 className="title split-text-right split-text-in-right split-lines">
//                   News & Update
//                 </h2>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="container">
//           <div className="blog-style-two-box">
//             <div className="row">
//               {loading ? (
//                 <h3 className="text-center">Loading Blogs...</h3>
//               ) : blogs.length > 0 ? (
//                 blogs.map((blog, index) => (
//                   <div className="col-xl-4 col-lg-6" key={blog.id || index}>
//                     <div className="blog-style-two fade-up-anim">
//                       <div className="thumb zoom-thumb">
//                         <a href={`/blog/${blog.slug}`}>
//                           <img
//                             className="img-reveal"
//                             src={
//                               blog.image && blog.image.img_md
//                                 ? `http://localhost/blog/${blog.image.img_md}`
//                                 : "https://via.placeholder.com/300"
//                             }
//                             alt={blog.title}
//                             style={{
//                               width: "100%",
//                               height: "250px",
//                               objectFit: "cover",
//                               border: "2px solid blue",
//                             }}
//                             onError={(e) => {
//                               console.log("FAILED:", e.target.src);
//                             }}
//                           />
//                         </a>
//                       </div>

//                       <div className="info">
//                         <div className="blog-one-meta">
//                           <ul>
//                             <li>
//                               <a href="#">
//                                 {blog.category?.name || "Technology"}
//                               </a>
//                             </li>

//                             <li>
//                               {new Date(blog.created_at).toLocaleDateString(
//                                 "en-US",
//                                 {
//                                   day: "2-digit",
//                                   month: "long",
//                                   year: "numeric",
//                                 },
//                               )}
//                             </li>
//                           </ul>
//                         </div>

//                         <h4 className="blog-title">
//                           <a href={`/blog/${blog.slug}`}>{blog.title}</a>
//                         </h4>

//                         <p>
//                           {blog.summary
//                             ? blog.summary.substring(0, 90) + "..."
//                             : ""}
//                         </p>

//                         <a href={`/blog/${blog.slug}`} className="btn-regular">
//                           Read more
//                         </a>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <h3 className="text-center">No Blogs Found</h3>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Blog;
